<template>
  <div class="address-page">
    <myHeader :title="title">
      <span slot="right-sum" class="add-address" @click.stop="goEdit(1)">添加收货地址</span>
    </myHeader>
    <Empty v-if="!address_list.length" :empty_type="{name: '暂无收货地址'}"></Empty>
    <div class="address-content" v-else>
      <div
        class="ac-item"
        v-for="(address,index) in address_list"
        :key="index"
        @click="payChoose(address.id)"
      >
        <img class="add-img" src="@/assets/images/book/address.png" alt />
        <div class="add-info">
          <p class="add-userinfo">
            <span>{{address.user_name}}</span>
            <font>{{address.mobile}}</font>
          </p>
          <p class="add-province">
            <span v-if="address.is_default==1">默认</span>
            <font>{{address.province_name+address.city_name+address.district_name+address.address}}</font>
          </p>
        </div>
        <div class="aci-btn" @click.stop="goEdit(2,address.id)">编辑</div>
      </div>
    </div>
  </div>
</template>

<script>
import myHeader from "@/components/Header";
import Empty from "@/components/Empty";
export default {
  name: "Address",
  components: {
    myHeader,
    Empty
  },
  data() {
    return {
      title: {
        name: "收货地址"
      },
      address_list: []
    };
  },
  created() {
    this.getAddress();
  },
  methods: {
    goEdit(type, id) {
      let query = {};
      if (type == 2) {
        //   编辑
        query.id = id;
      }
      this.$router.push({
        name: "AddressEdit",
        query
      });
    },
    async getAddress() {
      this.address_list = await this.$http.get("/api/app/address");
    },
    payChoose(id) {
      if (this.$route.query.payChoose) {
        this.$store.commit("SET_PAY_ADDRESS", id);
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.address-page {
  .add-address {
    font-size: 26px;
  }
  .address-content {
    border-top: 1px solid #f5f5f5;
  }
  .ac-item {
    padding: 30px;
    display: flex;
    align-items: center;
    background: #fff;
    min-height: 120px;
    .add-img {
      width: 58px;
      height: 58px;
      margin-left: 30px;
      flex: none;
    }
    .add-info {
      flex: 1;
      margin-left: 20px;
      .add-userinfo {
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        span {
          font-size: 28px;
          color: rgba(32, 36, 42, 1);
        }
        font {
          padding-left: 10px;
          font-size: 24px;
          color: rgba(140, 140, 140, 1);
        }
      }
      .add-province {
        padding-top: 6px;
        font-size: 22px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(32, 36, 42, 1);
        line-height: 32px;
        span {
          display: inline-block;
          width: 60px;
          height: 30px;
          background: rgba(231, 77, 61, 0.06);
          border-radius: 8px;
          border: 1px solid rgba(231, 77, 61, 0.3);
          font-size: 20px;
          color: rgba(231, 77, 61, 1);
          text-align: center;
          margin-right: 6px;
        }
      }
    }
    .aci-btn {
      flex: none;
      margin-left: 20px;
      width: 104px;
      height: 46px;
      background: rgba(231, 77, 61, 0.06);
      border-radius: 24px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(231, 77, 61, 1);
      line-height: 46px;
      text-align: center;
    }
  }
}
</style>
